module.exports = __webpack_public_path__ + "img/elect.8563d6ac.png";